var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoPinterest = function SvgLogoPinterest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "-0.75 -0.75 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.188 9.628a3.8 3.8 0 0 1-.15-1.078 5.12 5.12 0 0 1 5.324-5.175c2.907 0 4.5 1.772 4.5 4.144 0 3.112-1.378 5.747-3.43 5.747-1.135 0-1.529-.863-1.266-2.007.393-1.64 2.54-4.368 0-4.93S8.23 8.99 8.184 10.452l-1.556 6.563a13.6 13.6 0 0 0 0 4.603.16.16 0 0 0 .29.075 13 13 0 0 0 2.148-3.881c.15-.544.703-2.625.703-2.625a3.47 3.47 0 0 0 2.962 1.509c3.89 0 6.685-4.256 6.685-9.01 0-3.59-3.047-6.937-7.67-6.937-5.755 0-8.662 4.125-8.662 7.566A5.03 5.03 0 0 0 4.96 12.6z"
  })));
};
export default SvgLogoPinterest;